import {Toast} from "services/notification/toast";
import {isApiError, isNativeError, isSerializedError} from "utils/error";

export const handleSuccess = (message?: string) => {
  Toast.success(message ?? "Success");
};

export const handleInfo = (message: string) => {
  Toast.info(message ?? "Info");
};
/**
 * Handles various error types and displays a user-friendly error message using the Toast system.
 *
 * - Supports ApiError instances that may include: message, userMessage
 * - Supports serialized errors {message, code}
 * - Supports native Error
 * - Falls back to a generic message
 *
 * Optional reset callback will be invoked after showing the toast. If you have a toast API that
 * exposes an onClose callback, you can call reset there instead; this function calls reset()
 * immediately after showing the toast to guarantee state reset in environments without toast callbacks.
 *
 * @param error - unknown error to handle
 */
export const handleError = (error: unknown) => {
  let message = "Something went wrong";

  if (isApiError(error)) {
    // If there's a user-friendly message exposed by ApiError, prefer it
    const userMessage = error.userMessage ?? error.message;
    if (userMessage) {
      message = userMessage;
    }
  } else if (isSerializedError(error)) {
    message = error.message ?? message;
  } else if (isNativeError(error)) {
    message = error.message ?? message;
  } else if (typeof error === "string") {
    message = error;
  } else {
    const maybeMsg = (error as any)?.message;
    if (typeof maybeMsg === "string") message = maybeMsg;
  }

  Toast.error(message);

  return message;
};
